import axios from 'axios';
import { API_BASE } from './config';
import { supabase } from './supabase';

const getApi = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return axios.create({
    baseURL: API_BASE,
    headers: { 'Authorization': `Bearer ${session?.access_token}` }
  });
};

export const getLocations = async () => (await getApi()).get('/locations');
export const addLocation = async (data) => (await getApi()).post('/locations', data);
export const deleteLocation = async (id) => (await getApi()).delete(`/locations/${id}`);

export const getScreens = async (location_id) => (await getApi()).get('/screens', { params: { location_id } });
export const addScreen = async (data) => (await getApi()).post('/screens', data);
export const deleteScreen = async (id) => (await getApi()).delete(`/screens/${id}`);
export const assignPlaylist = async (id, playlist_id) => (await getApi()).patch(`/screens/${id}/playlist`, { playlist_id });
export const forceUpdate = async (id) => (await getApi()).post(`/screens/${id}/force-update`);

export const getPlaylists = async () => (await getApi()).get('/playlists');
export const addPlaylist = async (data) => (await getApi()).post('/playlists', data);
export const deletePlaylist = async (id) => (await getApi()).delete(`/playlists/${id}`);
export const getPlaylistItems = async (id) => (await getApi()).get(`/playlists/${id}/items`);
export const addPlaylistItem = async (id, content_id) => (await getApi()).post(`/playlists/${id}/items`, { content_id });
export const removePlaylistItem = async (id, content_id) => (await getApi()).delete(`/playlists/${id}/items/${content_id}`);

export const getContents = async () => (await getApi()).get('/contents');
export const uploadContent = async (formData) => (await getApi()).post('/contents/upload', formData);
export const addContent = async (data) => (await getApi()).post('/contents', data);
export const deleteContent = async (id) => (await getApi()).delete(`/contents/${id}`);

export const getAdminUsers = async () => (await getApi()).get('/admin/users');

export const updateOrientation = async (id, orientation) => (await getApi()).patch(`/screens/${id}/orientation`, { orientation });

